// use-fetch-data.js
import { useEffect, useState } from "react";
import { GET_TECHNICALDEPUTY_DESIGNCONTRACTLIST } from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";

const api = new APIClient();

interface Contract {
  customerName: string;
  projectCode: string;
  date: string;
  conNumber: string;
  potNumber: string;
  id: number;
  approvedByTechnicalDeputy: boolean;
}

interface Contracts {
  contractDesigns: Contract[];
}

let val: Contracts;

const useFetchData = () => {
  const [data, setData] = useState(val);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await api
          .get(GET_TECHNICALDEPUTY_DESIGNCONTRACTLIST, null)
          .then((response) => {
            setData(JSON.parse(JSON.stringify(response)));
            setLoading(false);
          });
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  return {
    data,
    loading,
  };
};

export default useFetchData;
